// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3osZD","spinnerAlign":"App_spinnerAlign__21T1Q","space":"App_space__qgEAg","img":"App_img__2OPCR"};